import React, { useRef } from 'react';
import __, { __route } from 'localisation';
import Heading from 'components/Heading';
import ListButton from '../ListButton';

const UnfinishedRegistrations = ({private_persons, companies}) => {
  const unfinishedRegistrations = useRef([]);

  const persons = private_persons || [];
  const comps = companies || [];

  unfinishedRegistrations.current = [...persons, ...comps.map(item => { item.isCompany = true; return item; })]
    .reduce((arr, item) => {
      const unfinishedPolicies = item.policies
        .filter((policy) => {
          return policy.status !== 'issued';
        }).map((policy) => {
          policy.profileName = item.name;
          policy.isCompany = item.isCompany;
          policy.nationalIdentityNumber = item.national_identity_number;
          policy.profileUuid = item.uuid;
          return policy;
        });
      arr = [...arr, ...unfinishedPolicies];
      return arr;
    }, []);

  return (
    <>
      {unfinishedRegistrations.current.length > 0 && (
        <>
          <Heading size="4" className="s-bottom-m">{__('started_registration')}</Heading>
          <div className='flex'>
            {unfinishedRegistrations.current.map((item: any) => (
              <ListButton
                key={item.id}
                href={`${__route("register_summary")}/${item.profileUuid}/${item.uuid}`}
                title={item.profileName}
                text={`${item.isCompany ? 'Organisationsnummer' : 'Personnummer'}: ${item.nationalIdentityNumber}`}
                icon={item.isCompany ? 'Briefcase 2' : 'Single Neutral Actions Add by Streamlinehq'}
              />
            ))}
          </div>
        </>
      )}

    </>
  )

};

export default UnfinishedRegistrations;